<div class="fdx-c-modal">
    <div class="fdx-c-modal__backdrop"></div>
    <div class="fdx-c-modal__main" [ngClass]="{
            'fdx-c-modal__main--small': modalDialogType==='SMALL',
            'fdx-c-modal__main--medium':modalDialogType==='MEDIUM',
            'fdx-c-modal__main--large':(modalDialogType==='LARGE'),
            'fdx-c-modal__main--full-height': modalDialogType==='FULL_HEIGHT',        
            'fdx-c-modal__main--': modalDialogType==='DEFAULT'
          }">

        <form [formGroup]="radioBtnFormGroup">

            <div class="fdx-c-modal__body">
                <ng-container *ngIf="!validationErrorMessage">
                    <h3 class="fdx-c-modal__title" style="font-weight: bold;"> {{modalDialogHeaderContent}}
                        <span class="no-wrap" style="font-weight: 300; text-align: center;">
                            {{"COMMON.CommonAddressvalidPara_Wehavelocatedtheaddresspleaseverifythefollowing" | translate: {Default: "We have located the address, please verify the following"} }}
                        </span>
                    </h3>
                </ng-container>

                <ng-container *ngIf="validationErrorMessage">
                    <div class="fdx-u-mb--4" style="text-align: center;">
                        <span style="font-size: 2em; color: #666;">&#9888;</span>
                        <p style="font-weight: 400; margin-top: 4px;">{{validationErrorMessage}}</p>
                    </div>
                </ng-container>

                <h6 class="fdx-c-modal__description">
                    {{"COMMON.CommonAddressvalidPara_Addressasentered" | translate: {Default: "ADDRESS AS ENTERED"} }}
                </h6>
                <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group fdx-li-tx"
                    formControlName="radioSelection">
                    <div *ngIf="addressAsEntered;else other_content">
                        <mat-radio-button #button class="example-radio-button address-content"
                            *ngFor="let enteredAddress of modalInputAddressData.addresses;index as i" [value]="0"
                            (click)="checkState(button)">                         
                                {{enteredAddress?.addressLines}} ,
                                {{enteredAddress?.city}},
                                {{enteredAddress?.stateProvinceCode}}, {{enteredAddress?.postalCode}},
                                {{enteredAddress?.countryCode}}                          
                        </mat-radio-button>
                    </div>
                <ng-template #other_content>
                <ng-container *ngFor="let enteredAddress of modalInputAddressData.addresses;index as i">
                    <label class="fdx-c-form-group__label" style="font-weight: 400;">
                        {{enteredAddress?.addressLines}} ,
                        {{enteredAddress?.city}},
                        {{enteredAddress?.stateProvinceCode}}, {{enteredAddress?.postalCode}},
                        {{enteredAddress?.countryCode}}
                    </label>
                </ng-container>
                </ng-template>
                
                <!-- Bypass Warning -->
                <div *ngIf="showBypassWarning" class="fdx-u-mt--2 fdx-u-mb--2" style="border: 1px solid #ff9900; border-radius: 4px; padding: 8px 12px; background-color: #fff8e6; display: flex; align-items: flex-start;">
                    <span style="color: #ff9900; font-size: 1.2em; margin-right: 8px;">&#9888;</span>
                    <span style="font-size: 0.85em;">
                        <strong>{{"COMMON.CommonAddressvalidLabel_Warning" | translate: {Default: "Warning:"} }}</strong>
                        {{"COMMON.CommonAddressvalidPara_Bypassaddressvalidationwarning" | translate: {Default: "You are about to bypass address validation. Unverified addresses may result in delivery delays or return-to-sender fees."} }}
                    </span>
                </div>

                <div class="fdx-o-grid fdx-u-mt--2 fdx-u-pt--2 fdx-o-grid__item--12"></div>

                <ng-container *ngIf="!validationErrorMessage">
                <h6 class="fdx-c-modal__description">
                    {{"COMMON.CommonAddressvalidPara_Addresswefound" | translate: {Default: "ADDRESS WE FOUND"} }}
                </h6>
                <div *ngIf="modalStandardizedAddressData?.length > 0;else no_content">
                    <mat-radio-button #button class="example-radio-button address-content" *ngFor="let suggestedAddress of modalStandardizedAddressData;index as i" [value]="1" (click)="checkState(button)">
                            {{suggestedAddress?.addressLines}} ,
                            {{suggestedAddress?.city}},
                            {{suggestedAddress?.stateProvinceCode}}, {{suggestedAddress?.postalCode}},
                            {{suggestedAddress?.countryCode}}
                    </mat-radio-button>
                 </div>
                 <ng-template #no_content>                  
                    No address found                     
                </ng-template>
                </ng-container>
                </mat-radio-group>
                <div class="fdx-o-grid fdx-u-mt--2 fdx-u-pt--2 fdx-o-grid__item--12"></div>


                <!-- Action Button -->
                <div class="row">
                    <div class="col-lg-12 col-sm-12">
                        <div class="fxg-button--float-right fdx-u-mt--4 fdx-u-mb--4">
                            <button class="fdx-c-button fdx-c-button--text fxg-margin-right"
                                (click)="raiseModalEvent('cancel')" translate>
                                {{"APP.AppButton_Cancel" | translate: {Default: "CANCEL"} }}
                            </button>
                            <button [hidden]="showLoadingButton" (click)="raiseModalEvent('submit')"
                                [disabled]="radioBtnFormGroup.status === 'INVALID'"
                                class="fdx-c-button fdx-c-button--primary fxg-margin-right">
                                {{modalButtonVal}}
                            </button>
                            <button [hidden]="!showLoadingButton"
                                class="fdx-c-button fdx-c-button--primary fdx-c-button--min-width fdx-c-button--loading loading-btn-post"
                                aria-label="Continue" disabled="disabled">
                                <span class="fdx-c-button__title" hidden>
                                    {{"APP.AppButton_Continue" | translate: {Default: "Continue"} }}
                                </span>
                                <span class="fdx-c-button__loading">
                                    <div class="fdx-c-loading-indicator  fdx-c-loading-indicator--white">
                                        <div class="fdx-c-loading-indicator__part"></div>
                                        <div class="fdx-c-loading-indicator__part"></div>
                                        <div class="fdx-c-loading-indicator__part"></div>
                                        <div class="fdx-c-loading-indicator__part"></div>
                                    </div>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </form>
    </div>
</div>